import React, { useState } from 'react'
import { Grid, TextField } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import { Dialog, snackbar } from 'components'
import { useCheckFormErrors, useApiCall } from 'hooks'

import { UserPoll, CreateUserPollPayload, CreateUserPollResponse } from '../../types'
import { createUserPoll } from '../../api'
import { constants } from '../../constansts'

const rules = {
  question: [
    {
      validate: (value: string) => !value || value.length <= 254,
      message: 'No puede superar los 254 caracteres',
    },
  ],
}

const requiredFields = ['question', 'active']

interface CreateUserPollDialogProps {
  handleClose: () => void
  onDone: (newUserPoll: UserPoll) => void
}

const CreateUserPollDialog: React.FC<CreateUserPollDialogProps> = ({ handleClose, onDone }) => {
  const [multiple_answers, setMultipleAnswers] = useState(false)

  const [question, setQuestion] = useState('')
  const [active] = useState(false)

  const [createUserPollApi, isLoading] = useApiCall<CreateUserPollPayload, CreateUserPollResponse>(
    createUserPoll,
  )

  const handleChangeMultipleAnswers: React.ChangeEventHandler<HTMLInputElement> = e => {
    setMultipleAnswers(e.target.checked)
  }

  const handleQuestionChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    setQuestion(e.target.value)
  }

  const fields = { question, active }
  const { hasErrors, isAnyFieldEmpty, errors } = useCheckFormErrors(fields, rules, requiredFields)
  const isSubmitDisabled = hasErrors || isAnyFieldEmpty || isLoading

  const onCreateUserPoll = async () => {
    if (!question) return
    const userPoll = {
      question,
      active,
      multiple_answers,
    }
    try {
      const { userPoll: newUserPoll } = await createUserPollApi(userPoll)
      onDone(newUserPoll)
    } catch (err) {
      console.error(err)
      snackbar.show(`No se pudo crear ${constants.TEST_NAME}. Intente de nuevo.`)
    }
  }

  return (
    <Dialog
      title={`Nuevo ${constants.TEST_NAME}`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Crear"
      okButtonProps={{ disabled: isSubmitDisabled }}
      onAccept={onCreateUserPoll}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Pregunta"
            value={question}
            fullWidth
            onChange={handleQuestionChange}
            disabled={isLoading}
            multiline
            error={errors.question.hasError}
            helperText={errors.question.message}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={multiple_answers}
                onChange={handleChangeMultipleAnswers}
                color="primary"
                disabled={isLoading}
              />
            }
            label="Múltiples respuestas"
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { CreateUserPollDialog }
